// extracted by mini-css-extract-plugin
export var lg = "breakpoints-module--lg--b8e63";
export var md = "breakpoints-module--md--a00ca";
export var over1200 = "breakpoints-module--over1200--348c0";
export var over1400 = "breakpoints-module--over1400--19991";
export var over600 = "breakpoints-module--over600--487f6";
export var over900 = "breakpoints-module--over900--2df0c";
export var px1200 = "breakpoints-module--px1200--5b3f8";
export var px1400 = "breakpoints-module--px1400--57852";
export var px600 = "breakpoints-module--px600--ecc08";
export var px900 = "breakpoints-module--px900--72e0e";
export var sm = "breakpoints-module--sm--8d623";
export var upto1200 = "breakpoints-module--upto1200--56d80";
export var upto1400 = "breakpoints-module--upto1400--13f15";
export var upto600 = "breakpoints-module--upto600--e5055";
export var upto900 = "breakpoints-module--upto900--6d983";
export var xs = "breakpoints-module--xs--0b010";